module.exports = __webpack_public_path__ + "img/file.d39bde12.svg";